<div class="video-player">
  <div [hidden]="state() !== 'empty'" class="video-slot-empty"></div>
  <vb-lxp-video-player [hidden]="state() !== 'playing'" #mvPlayer></vb-lxp-video-player>
</div>

@if (showBadge && label && mvPlayer && mvPlayer.streamData) {
  <div class="stream-badge" (click)="onCloseClicked()">
    <div class="stream-badge-dot"></div>
    @if (mvPlayer && mvPlayer.streamData && mvPlayer.streamData.carNumber) {
      <span class="stream-badge-text"># {{ mvPlayer.streamData.carNumber }}</span>
    } @else if (mvPlayer && mvPlayer.streamData.id === 'main-stream') {
      <span class="stream-badge-text">Main Stream</span>
    } @else {
      <span class="stream-badge-text">Twitch Stream</span>
    }
    <div class="stream-badge-close">✕</div>
  </div>
}
